export default __webpack_public_path__ + "static/pragicts-ai-banner-private-ai-a0fb4fcfe99bde1eac2c906c823340c0.jpg";